import { motion, AnimatePresence } from "framer-motion";

const ProjectModal = ({ project, onClose, index, setIndex }) => {
    if (!project) return null;

    const next = () => setIndex((prev) => (prev + 1) % project.images.length);
    const prev = () => setIndex((prev) => (prev - 1 + project.images.length) % project.images.length);

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 z-50 bg-black/80 backdrop-blur flex items-center justify-center"
                onClick={onClose}
            >
                <motion.div
                    initial={{ scale: 0.9, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.9, opacity: 0 }}
                    className="bg-black rounded-xl max-w-5xl w-full p-6 relative"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* CLOSE */}
                    <button
                        onClick={onClose}
                        className="absolute top-4 right-4 text-white text-2xl z-50"
                    >
                        ✕
                    </button>

                    {/* IMAGE */}
                    <div className="relative">
                        <img
                            src={project.images[index]}
                            alt=""
                            className="w-full max-h-[70vh] object-contain rounded-lg"
                        />

                        {/* ARROWS */}
                        {project.images.length > 1 && (
                            <>
                                <button
                                    onClick={prev}
                                    className="absolute left-2 top-1/2 -translate-y-1/2 text-white text-3xl 
                       bg-black/30 hover:bg-black/50 rounded-full p-4"
                                    style={{ fontSize: '5rem' }}
                                >
                                    ‹
                                </button>
                                <button
                                    onClick={next}
                                    className="absolute right-2 top-1/2 -translate-y-1/2 text-white text-3xl 
                       bg-black/30 hover:bg-black/50 rounded-full p-4"
                                    style={{ fontSize: '5rem' }}
                                >
                                    ›
                                </button>
                            </>
                        )}
                    </div>

                    {/* INFO */}
                    <div className="mt-4 text-white">
                        <h3 className="text-xl font-semibold">{project.title}</h3>
                        <p className="opacity-80 mt-1">{project.description}</p>

                        {/* LINKS */}
                        <div className="flex gap-4 mt-3">
                            {project.links?.map((link) => (
                                <a
                                    key={link.url}
                                    href={link.url}
                                    target="_blank"
                                    className="text-secondary hover:underline"
                                >
                                    {link.text}
                                </a>
                            ))}
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default ProjectModal;